<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  components: {},

  data() {
    return {
      isLoading: true,
      currentUrl: "",
      prevRoute: ""
    };
  },
  watch: {
    $route(pathUrl) {
      this.currentUrl = pathUrl.path;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 1500);
    }
  },
  mounted() {
    this.currentUrl = window.location.pathname;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }
};
</script>
